import { render, staticRenderFns } from "./FreelancerEdit.vue?vue&type=template&id=61d19e8b&scoped=true&"
import script from "./FreelancerEdit.vue?vue&type=script&lang=js&"
export * from "./FreelancerEdit.vue?vue&type=script&lang=js&"
import style0 from "./FreelancerEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FreelancerEdit.vue?vue&type=style&index=1&id=61d19e8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d19e8b",
  null
  
)

export default component.exports